import React from "react"
import type { BlogV2TagParsed } from "types/blog-v2-types"
import { blogSlug } from "components/Blog/utils/Blog.utils"

import { container, navItemsContainer } from "./DesktopBlogNav.css"

type Props = {
  navItems: BlogV2TagParsed[]
  currentPage: string
  locale: "en-GB" | "en-US"
}

export const DesktopBlogNav: React.FC<Props> = ({
  navItems,
  currentPage,
  locale,
}) => {
  const latest = {
    title: "Latest",
    slug: blogSlug,
  }

  const itemsToPost = [latest, ...navItems]

  const blogSlugLocale = locale === "en-US" ? `/us${blogSlug}` : blogSlug
  return (
    <div className={container}>
      <div className={navItemsContainer}>
        {itemsToPost.map((navItem) => {
          const { title, slug } = navItem
          return (
            <a
              key={slug}
              title={title}
              aria-label={title}
              data-testid={`blog-nav-${slug}`}
              rel="noopener noreferrer"
              href={
                title === "Latest"
                  ? blogSlugLocale
                  : `${blogSlugLocale}/tag/${slug}`
              }
              className={slug === currentPage ? "active" : ""}
            >
              {title}
            </a>
          )
        })}
      </div>
    </div>
  )
}
